import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Scrollbars } from "react-custom-scrollbars";

import { getResources, resetField } from "../../../store/actions";
import Loader from "../../../sharedComponents/preloader";
import { objToQueryString } from "../../../utils/common";

const SearchResources = ({
	next,
	resourceList,
	history,
	match,
	resetField,
	getResources,
	selected,
	title = null,
	className = "",
	footer = null,
	highlightSelected = true
}) => {
	const [searchResourceValue, setSearchResourceValue] = useState("");
	const [atBottom, setAtBottom] = useState(false);
	const [resources, setResources] = useState([]);

	const [filters, setFilters] = useState({ limit: 20, search: "" });
	const [query, setQuery] = useState();

	useEffect(() => {
		setQuery(objToQueryString(filters));
	}, [filters]);

	useEffect(() => {
		if (query) {
			setResources([]);
			getResources(query);
		}
	}, [query, getResources]);

	useEffect(() => {
		return () => {
			setResources([]);
			resetField("Resources.resourcesResult", {});
		}
	}, [resetField]);

	useEffect(() => {
		setResources((prevState) => [...prevState, ...resourceList]);
		setAtBottom(false);
	}, [resourceList]);

	useEffect(() => {
		const paramsId = match && match.params && match.params.id;
		if (paramsId && !selected) {
			const resource = resources.filter(item => Number(item.id) === Number(paramsId));
			resetField("Resources.selectedResource", resource[0]);
		} else if (resources && resources.length && !selected) {
			resetField("Resources.selectedResource", resources[0]);
		}
	}, [match, resources, selected, resetField]);

	const handleScrollFrame = (e) => {
		if (e.top === 1) {
			setAtBottom(true);
			if (next && atBottom) {
				getResources(next);
			}
		}
	};

	let searchTimeout = null;
	const onSearch = ({ target }) => {
		const value = target.value;
		setSearchResourceValue(value);
		clearTimeout(searchTimeout);
		searchTimeout = setTimeout(() => {
			setFilters(value && value.length > 2 ? { ...filters, search: value } : { ...filters, search: "" });
		}, 500);
	};

	const resetSelected = (item) => {
		resetField("Resources.selectedResource", item, () => {
			resetField("Resources.resourcesResult", {}, () => {
				history.push(`/nutrition/resources/${item.id}/details`);
			})
		});
	};

	const renderResourceList = (list) => {
		return list.map((item) => {
			return (
				<li
					className={`dropdown-item pointer ${highlightSelected && selected && selected.id === item.id ? "active" : ""}`}
					key={item.id}
					onClick={() => resetSelected(item)}>
					{item.title}
				</li>
			);
		});
	};

	return (
		<React.Fragment>
			<div className={`card card-primary w-100 h-100 m-0 border-0 ${className}`}>
				<div className="p-3">
					{title && <h4 className="text-primary-dark mb-3">{title}</h4>}
					<div className="form-group m-0">
						<i className="icon icon-search field-icon text-primary-dark" />
						<input
							name="Search"
							className="form-control"
							placeholder="Search"
							type="text"
							value={searchResourceValue}
							onChange={onSearch}
						/>
					</div>
				</div>
				<Scrollbars onScrollFrame={handleScrollFrame}>
					<ul className="dropdown-list pb-3">
						{resources && resources.length ? (
							renderResourceList(resources)
						) : (
								<li className="text-center alert alert-info mx-3">No items found!</li>
							)}
					</ul>
					{atBottom && next ? <Loader /> : null}
				</Scrollbars>
				{footer}
			</div>
		</React.Fragment>
	);
};

const mapDispatchToProps = { getResources, resetField };
const mapStateToProps = (state) => {
	const { Resources } = state;
	return {
		next: get(Resources, "resourcesResult.next"),
		resourceList: get(Resources, "resourcesResult.results", []),
		selected: get(Resources, "selectedResource", null)
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchResources);
